import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SmtpConfigRoutingModule } from './smtp-config-routing.module';
import { SmtpConfigComponent } from './smtp-config.component';
import {
  DxSelectBoxModule, DxTextBoxModule, DxDateBoxModule, DxCheckBoxModule,DxSwitchModule,
  DxValidatorModule, DxButtonModule, DxLoadPanelModule, DxPopupModule, DxSliderModule, DxTextAreaModule, DxValidationSummaryModule
} from 'devextreme-angular';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';


@NgModule({
  declarations: [SmtpConfigComponent],
  imports: [
    CommonModule,
    DevEpressCommonModule,
    DxPopupModule,
    DxTextAreaModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxDateBoxModule,
    DxSliderModule,
    FormsModule,
    ReactiveFormsModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTextBoxModule,DxSwitchModule,
    DxButtonModule, DxPopupModule, DxLoadPanelModule,
    SmtpConfigRoutingModule
  ]
})
export class SmtpConfigModule { }
